import { Component } from '@angular/core';
import { Field } from '../../field';
import { LayoutService } from '../../layout.service';

@Component({
  selector: 'app-input-map',
  templateUrl: './input-map.component.html',
  styleUrls: ['./input-map.component.less']
})
export class InputMapComponent extends Field {
  constructor(public layoutService: LayoutService) {
    super(layoutService);
  }

  openMap() {
    window.open('https://www.bing.com/maps?q=' + encodeURI(this.recordProperty.ValueAsObject));
  }
}
